/**
 * Libs
 */
import React from 'react';
import { Spacing } from 'src/ui/common/atoms/spacing';

/**
 * Components
 */
import { Typography } from 'src/ui/common/atoms/typography';
import { TechPageContent } from './components/tech-page-content';
import { TechPageHeader } from './components/tech-page-header';
import { TechPageSection } from './components/tech-page-section';

export const TechTermsContainer = () => (
    <>
        <TechPageHeader title="Terms of Service" subtitle="Effective Date: 08th September 2023" />
        <TechPageContent>
            <TechPageSection title="Introduction">
                <Typography color="text" tag="p">
                    Welcome to Tech Contemporary, a cutting-edge Web2 platform for digital art enthusiasts, creators,
                    and collectors. These Terms of Service ("Terms") govern your access to and use of the Tech
                    Contemporary platform and services. Please read these Terms carefully before using our platform. By
                    accessing or using Tech Contemporary, you agree to be bound by these Terms. If you do not agree to
                    these Terms, please do not use our platform.
                </Typography>
                <Spacing padding="0 30px">
                    <Typography color="text" tag="p" semiBold>
                        1. Acceptance of Terms
                    </Typography>
                    <Typography color="text" tag="p">
                        By accessing or using Tech Contemporary, you agree to these Terms and our Privacy Policy, which
                        is incorporated into these Terms by reference. If you do not agree with any part of these Terms
                        or our Privacy Policy, please do not use our platform.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        2. Use of Tech Contemporary
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.1 Eligibility
                    </Typography>
                    <Typography color="text" tag="p">
                        You must be at least 18 years old to use Tech Contemporary. By using our platform, you represent
                        and warrant that you are 18 years of age or older.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.2 User Account
                    </Typography>
                    <Typography color="text" tag="p">
                        To access certain features of Tech Contemporary, you may be required to create a user account.
                        You are responsible for maintaining the security of your account information and for all
                        activities that occur under your account. You must notify us immediately of any unauthorized use
                        of your account.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.3 Content Submission
                    </Typography>
                    <Typography color="text" tag="p">
                        You may upload, post, or share digital art and related content on Tech Contemporary. By
                        submitting content, you grant Tech Contemporary a non-exclusive, worldwide, royalty-free license
                        to use, modify, reproduce, and distribute your content for the purpose of operating and
                        promoting our platform.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.4 Prohibited Content
                    </Typography>
                    <Typography color="text" tag="p">
                        You may not upload, post, or share any content that violates applicable laws or our content
                        guidelines. Prohibited content includes, but is not limited to, content that is obscene,
                        defamatory, infringing on intellectual property rights, or incites violence.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.5 Intellectual Property
                    </Typography>
                    <Typography color="text" tag="p">
                        Tech Contemporary respects intellectual property rights. You may not upload, post, or share
                        content that infringes on the intellectual property rights of others. If you believe your
                        intellectual property rights have been violated, please contact us.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.6 Code of Conduct
                    </Typography>
                    <Typography color="text" tag="p">
                        You agree to adhere to a code of conduct while using Tech Contemporary, including treating
                        others with respect and refraining from harassment, hate speech, or any disruptive behavior.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        3. Payments and Transactions
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        3.1 Transactions
                    </Typography>
                    <Typography color="text" tag="p">
                        Tech Contemporary may facilitate transactions between creators and collectors of digital art.
                        Any transactions conducted through our platform are subject to separate terms and conditions
                        provided by Tech Contemporary or third-party payment processors.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        3.2 Fees
                    </Typography>
                    <Typography color="text" tag="p">
                        Tech Contemporary may charge fees for certain services, which will be clearly disclosed to you
                        before you use such services. You agree to pay all fees associated with your use of our
                        platform.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        4. Termination
                    </Typography>
                    <Typography color="text" tag="p">
                        Tech Contemporary reserves the right to terminate or suspend your access to our platform at our
                        sole discretion, with or without cause. Upon termination, your account and all associated
                        content may be deleted.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        5. Privacy
                    </Typography>
                    <Typography color="text" tag="p">
                        Your use of Tech Contemporary is subject to our Privacy Policy, which explains how we collect,
                        use, and protect your personal information.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        6. Changes to Terms
                    </Typography>
                    <Typography color="text" tag="p">
                        Tech Contemporary may update these Terms from time to time. Any changes will be posted on our
                        platform, and your continued use of Tech Contemporary after such changes constitute your
                        acceptance of the revised Terms.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        7. Contact Us
                    </Typography>
                    <Typography color="text" tag="p">
                        If you have any questions or concerns about these Terms or Tech Contemporary, please contact us
                        at <a href="mailto:emil@techcontemporary.com">emil@techcontemporary.com.</a>
                    </Typography>
                </Spacing>
            </TechPageSection>
            <TechPageSection>
                <Typography color="text" tag="p">
                    By using Tech Contemporary, you acknowledge that you have read, understood, and agreed to these
                    Terms of Service. Thank you for choosing Tech Contemporary as your platform for digital art
                    exploration and creation.
                </Typography>
            </TechPageSection>
        </TechPageContent>
    </>
);